import "./App.css";
import { Routes, Route } from "react-router-dom";

import LoginRegister from './loginpages/LoginRegister';
import RegisterVerifyOtp from './loginpages/RegisterVerifyOtp';
import RegisterAccount from './loginpages/RegisterAccount';
// import UploadRegister from './loginpages/UploadRegister';
import CreatePassword from './loginpages/CreatePassword';
import CompanyOverview from "./loginpages/CompanyOverview";
import ProductionDetails from "./loginpages/ProductionDetails";
import Certifications from "./loginpages/Certifications";
import DocumentsUpload from "./loginpages/DocumentsUpload";
import OperationalData from "./loginpages/OperationalData";
import Electrical from "./loginpages/Electrical";
import Hvac from "./loginpages/Hvac";
import Scada from "./loginpages/Scada";
import Building from "./loginpages/Building";
import Equipment from "./loginpages/Equipment";
import Overview from "./loginpages/Overview";

function App() {
  return (
    <>
      <Routes>
       
 <Route path='/' element={ <LoginRegister/>}></Route>
 <Route path='registerverifyotp' element={ <RegisterVerifyOtp/>}></Route>
 <Route path='registeraccount' element={ <RegisterAccount/>}></Route>
 {/* <Route path='uploadregister' element={ <UploadRegister/>}></Route> */}
 <Route path='createpassword' element={ <CreatePassword/>}></Route>
  <Route path="/company" element={<CompanyOverview />}></Route>
        <Route
          path="/productiondetails"
          element={<ProductionDetails />}
        ></Route>
        <Route path="/certifications" element={<Certifications />}></Route>
        <Route path="/documentsupload" element={<DocumentsUpload />}></Route>
        <Route path="/operationaldata" element={<OperationalData />}></Route>
        <Route path="/electrical" element={<Electrical />}></Route>
        <Route path="/hvac" element={<Hvac />}></Route>
        <Route path="/scada" element={<Scada />}></Route>
        <Route path="/building" element={<Building />}></Route>
        <Route path="/equipment" element={<Equipment />}></Route>
        <Route path="/overview" element={<Overview />}></Route>
      </Routes>
    </>
  );
}

export default App;
